
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('common');

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/8ed1a4bf5d34ba9d7d5d4378bb49342a.jpg"
          alt="UmiGo Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-purple-900/40 via-pink-900/30 to-purple-900/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto" style={{ marginTop: '-5vh' }}>
        <h1 className="text-7xl md:text-8xl font-black text-white mb-6 leading-tight">
          <div className="mb-2">{t('hero.title1')}</div>
          <div className="mb-2 ml-8">{t('hero.title2')}</div>
          <div className="ml-16">{t('hero.title3')}</div>
        </h1>

        <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto font-light">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white rounded-full font-bold text-lg hover:bg-white/30 transition-all flex items-center gap-2 border-2 border-white/40 whitespace-nowrap">
            <i className="ri-play-circle-line"></i>
            {t('hero.watchDemo')}
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}